import {ApiResource} from '../../common/base/api-resource';

export class LawConservationConfigurationResource extends ApiResource {

  sphereId?: number;

}
